import * as React from "react";
import { FileText, FileIcon } from "lucide-react";
import { ICON_SIZES } from "@/lib/icon-sizes";
import { cn } from "@/lib/utils";

interface FileIconSVGProps {
  filename?: string;
  extension?: string;
  size?: number;
  className?: string;
}

export const FileIconSVG: React.FC<FileIconSVGProps> = ({ 
  filename = "",
  extension = "",
  size = ICON_SIZES.sm,
  className
}) => {
  const getFileExtension = (name: string) => {
    const parts = name.split('.');
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  };

  const ext = extension.toLowerCase() || getFileExtension(filename);
  let iconPath = "";

  switch (ext) {
    case 'pdf':
      iconPath = "assets/icons/pdf-icon.svg";
      break;
    case 'doc':
    case 'docx':
      iconPath = "assets/icons/microsoft-word-icon.svg";
      break;
    case 'xls':
    case 'xlsx':
      iconPath = "assets/icons/microsoft-excel-logo.svg";
      break;
    case 'msg':
    case 'eml':
      iconPath = "assets/icons/microsoft-outlook-icon.svg";
      break;
    case 'ppt':
    case 'pptx':
      return <FileText size={size} className={cn("text-brand-accent flex-shrink-0", className)} />;
    case 'txt':
      return <FileText size={size} className={cn("text-muted-foreground flex-shrink-0", className)} />;
    default:
      if (!filename && !ext) {
         // If no filename, might be a generic file icon needed
         return <FileIcon size={size} className={cn("text-muted-foreground flex-shrink-0", className)} />;
      }
      return <FileIcon size={size} className={cn("text-muted-foreground flex-shrink-0", className)} />;
  }

  return (
    <img 
      src={iconPath} 
      alt={ext} 
      style={{ width: size, height: size }} 
      className={cn("flex-shrink-0 object-contain", className)} 
    />
  );
};

export default FileIconSVG;
